import { CommitmentChat } from '../../../../coaching-base/general';
import { BehaviourItem } from '../../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../../coaching-tags/models/subbehaviour.coaching.model';
import { createAction } from '../../../../store.model';
import { ChatRequest } from '../../../../teams-call';
import { ActionType } from '../teamschat-dialog.action';

export interface Load {
    opts: ChatRequest;
}

export const load = createAction<ActionType, Load>(
    ActionType.COACHING_DETAIL__TCD__LOAD,
);

export interface LoadResult extends Load {
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    commitmentChat?: CommitmentChat;
}

export const loadResult = createAction<ActionType, LoadResult>(
    ActionType.COACHING_DETAIL__TCD__LOAD_RESULT,
);
